export default {
  detail: {
    title: "测试详情页",
    component: () =>
      import(
        /* webpackChunkName: "demo_detail" */ "@/mods/demo/subMod/DemoDetail"
      ),
  },
};
